exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stage-registration-card .stage-card-subscription{padding:1em}.stage-registration-card .card-header-title{line-height:1.25em;display:block}.stage-registration-card .stage-card-customers-tag .is-success.is-light{background-color:#effaf5;color:#257953;border-style:solid;border-width:1px;border-color:#257953}", ""]);

// exports
